<template>
  <basic-container id="exminetopic20211119">
    <avue-crud
      :option="option"
      v-if="reWrite"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      :upload-before="uploadBefore"
      :before-close="beforeClose"
      v-model="form"
      ref="crud"
      id="consumable20211203"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <!--<template slot="menuLeft">
        <el-button type="danger"
                   size="small"
                   icon="el-icon-delete"
                   plain
                   v-if="permission.consumable_delete"
                   @click="handleDelete">删 除
        </el-button>
      </template>-->
      <template slot-scope="scope" slot="price">
        <div class="money">
          <span>{{ tool.money_format_allowvoid(scope.row.price) }}</span>
        </div>
      </template>
      <template slot-scope="scope" slot="priceForm">
        <moneyInput
          v-model="form.price"
          placeholder="请输入 价格"
          :disabled="formDisabled"
          style="width: 100%"
        />
      </template>
      <template slot="projectIdForm" slot-scope="scope">
        <el-select
          v-model="form.projectId"
          :disabled="formProjectisabled"
          placeholder="项目名称"
          style="width: 100%"
          clearable
          @change="(value) => querySelect(value, 1)"
        >
          <el-option v-for="item in projectList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </template>
      <template slot="projectIdSearch">
        <el-select
          v-model="projectId"
          placeholder="项目名称"
          style="width: 100%"
          @change="(value) => querySelect(value, 2)"
        >
          <el-option v-for="item in projectList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </template>
      <template slot="typeNameForm" slot-scope="scope">
        <el-select
          :disabled="formDisabled"
          :value="form.typeName"
          v-model="form.typeName"
          ref="typeselectfef"
          placeholder="请输入 类型"
          clearable
          style="width: 100%"
        >
          <el-option :value="form.typeName" show-all-levels :label="form.typeName">
            <el-tree
              node-key="id"
              :data="treeFormData"
              :props="treeProps"
              :load="typeLazyLoadTree"
              lazy
              @node-click="typeNodeTreeClick"
            >
            </el-tree>
          </el-option>
        </el-select>
      </template>
      <template slot="typeNameSearch" slot-scope="scope">
        <el-select
          :value="query.typeName"
          v-model="query.typeName"
          placeholder="类型"
          style="width: 100%"
        >
          <el-option :value="query.typeName" show-all-levels :label="query.typeName">
            <el-tree
              node-key="id"
              :data="treeSearchData"
              :props="treeProps"
              :load="typeLazyLoadTree"
              lazy
              @node-click="typeNodeTreeClick"
            >
            </el-tree>
          </el-option>
        </el-select>
      </template>
      <template slot="measuringUnitSearch">
        <el-select v-model="query.measuringUnit" clearable placeholder="计量单位">
          <el-option
            v-for="item in measuringUnitList"
            :key="item"
            :label="item.dictValue"
            :value="item.dictKey"
          ></el-option>
        </el-select>
      </template>

      <template slot="attachIdsForm" slot-scope="scope">
        <el-upload
          action="/api/v4ward/oss/customEndpoint/put-file"
          list-type="picture-card"
          :headers="headers"
          :on-preview="handlePictureCardPreview"
          :on-remove="fileHandleRemove"
          :on-success="fileUploadSuccess"
          :before-upload="beforeAvatarUpload"
          :disabled="fileDisabled"
          :file-list="form.fileList"
          :limit="1"
          accept="image/*"
        >
          <i class="el-icon-plus"></i>
          <div slot="tip" class="el-upload__tip">只能上传一张图片文件，且不超过500kb</div>
        </el-upload>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-button type="text" size="small" @click="rowDel(scope.row)">&nbsp;删 除 </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { Base64 } from 'js-base64';
import settings from '@/config/vd-settings';
import { getToken } from '@/util/auth';

import { add, getDetail, getList, remove, update } from '@/api/crmedical/consumable/consumable';
import { mapGetters } from 'vuex';
import { getProjectList } from '@/api/crmedical/project/project';
import { tree } from '@/api/crmedical/consumable/consumabletype';
import { getProjectDict } from '@/api/crmedical/project-dictionary/project-dictionary';
import { getAttachByMainIdList } from '@/api/crmedical/attach/attach';

var inputNumberAndLetter = (rule, value, callback) => {
  var zg = /^[A-Za-z0-9]+$/;
  if (!zg.test(value)) {
    callback(new Error('请输入数字或字母'));
  } else {
    callback();
  }
};

export default {
  data() {
    return {
      serachFlag: true,
      todoListLength: 10000000000000000,
      formDisabled: false,
      formProjectisabled: false,
      //typeName: '',
      projectId: '',
      typeNameFlag: true,
      typeIdFlag: false,
      treeFormData: [],
      treeSearchData: [],
      typeTreeFlag: true,
      treeProps: {
        //标题
        label: 'name',
        //值
        value: 'id',
        //子节点
        children: 'zones',
        //是否叶子节点
        isLeaf: 'hasChildren',
        //本节点类型key值
        objectType: 'id',
        //本节点类型名
        objectTypeName: 'name',
      },
      projectList: [],
      measuringUnitList: [],
      form: {
        fileList: [],
          typeName:''
      },
      query: {
        measuringUnit: '',
      },
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      reWrite: false,
      attachIdList: [],
      fileDisabled: false,
      option: {
        dialogClickModal:false,
        dialogWidth: '65%',
        dialogHeight: 432,
        viewBtnIcon: false,
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: false,
        viewBtn: true,
        editBtn: true,
        searchMenuSpan: 18,
        delBtn: false,
        selection: true,
        columnBtn: true,
        align: 'left',
        column: [
          {
            label: '项目名称',
            prop: 'projectId',
            searchslot: true,
            formslot: true,
            searchClearable: false,
            search: true,
            type: 'tree',
            dicUrl: 'api/v4ward/project/getProjectList',
            cascaderItem: ['measuringUnit'],
            cascaderChange: true,
            props: {
              label: 'name',
              value: 'id',
            },
            rules: [
              {
                required: true,
                message: '请选择项目',
                trigger: 'change',
              },
            ],
            //display: false,
          },
          /*{
              label: "项目名称2",
              prop: "project",
              rules: [{
                required: true,
                message: "请选择项目名称",
                trigger: "blur"
              }],
              //formslot: true,
              search: true,
              searchslot:true,
              viewDisplay:false,
              addDisplay: false,
              editDisplay:false,
              hide: true,
            },*/

          {
            label: '耗材编号',
            prop: 'code',
            rules: [
              {
                required: true,
                message: '耗材编号',
                trigger: 'change',
              },
              {
                validator: inputNumberAndLetter,
                trigger: 'blur',
              },
            ],
            search: true,
            maxlength: 10,
            showWordLimit: true,
          },

          {
            label: '耗材名称',
            prop: 'name',
            rules: [
              {
                required: true,
                message: '耗材名称',
                trigger: 'change',
              },
            ],
            search: true,
            maxlength: 20,
            showWordLimit: true,
            overHidden: true,
          },

          {
            label: '类型',
            type: 'tree',
            prop: 'typeName',
            rules: [
              {
                required: true,
                message: '耗材类型',
                trigger: 'change',
              },
            ],
            search: true,
            formslot: true,
            viewDisabled: true,
            searchslot: true,
          },

          {
            label: '规格',
            prop: 'specification',
            maxlength: 20,
            rules: [
              {
                required: true,
                message: '规格',
                trigger: 'change',
              },
            ],
          },
          {
            label: '生产厂家',
            prop: 'vender',
            maxlength: 20,
            rules: [
              {
                required: false,
                message: '生产厂家',
                trigger: 'change',
              },
            ],
          },

          {
            label: '价格',
            align: 'right',
            prop: 'price',
            maxlength: 9,
            slot: true,
            formslot: true,
            rules: [
              {
                required: true,
                message: '请输入呈报金额',
                trigger: 'change',
              },
              {
                pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/,
                message: '请输入最多2位小数的金额',
              },
            ],
          },
          {
            label: '计量单位',
            prop: 'measuringUnit',
            searchslot: true,
            dataType: 'string',
            type: 'select',
            search: true,
            dicData: [],
            dicUrl:
              '/api/v4ward/projectDict/dictionary?code=project_consumable_measuring_unit&projectId={{key}}',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            rules: [
              {
                required: true,
                message: '计量单位',
              },
            ],
          },
          {
            label: '图片',
            prop: 'img',
            type: 'upload',
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            span: 24,
            propsHttp: {
              res: 'data',
              url: 'link',
              name: 'originalName',
            },
            //tip: '只能上传不超过5M的文件或图片',
            action: '/api/v4ward/oss/customEndpoint/put-file',
            dataType: 'string',
          },
          /*{
              label: "备注",
              prop: "description",
              maxlength: 20,
              rules: [{
                required: false,
                message: "请输入描述",
                trigger: "change"
              }]
            },*/
          {
            type: 'input',
            label: '电子附件',
            span: 24,
            hide: true,
            rules: [{ required: false }],
            display: true,
            formslot: true,
            //typeslot: true,
            prop: 'attachIds',
            required: false,
          },
        ],
      },
      data: [],
      viewFlag: false,
      headers: {},
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.consumable_add, false),
        viewBtn: this.vaildData(this.permission.consumable_view, false),
        delBtn: this.vaildData(this.permission.consumable_delete, false),
        editBtn: this.vaildData(this.permission.consumable_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    //初始化高度
    this.option.height = this.bodyHeight - 398;

    this.headers['Authorization'] = `Basic ${Base64.encode(
      `${settings.clientId}:${settings.clientSecret}`
    )}`;

    // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
    this.headers['Blade-Auth'] = 'bearer ' + getToken();
    //加载列表
    getProjectList({}).then((res) => {
      this.projectList = res.data;

      if (this.projectList.length > 0) {
        this.projectId = this.projectList[0].id;
        this.query.projectId = this.projectList[0].id;
        this.querySelect(this.projectList[0].id);
      }
      getProjectDict({ projectId: this.projectId, code: 'project_consumable_measuring_unit' }).then(
        ({ data }) => {
          if (this.operateType === 'add') {
            this.form.type = null;
          }
          const column1 = this.findObject(this.option.column, 'measuringUnit');
          this.measuringUnitList = data;
          // console.log(data);
          if (column1.dicData.length == 0) {
            column1.dicData = [{}];
          }
        }
      );

      this.$nextTick(() => {
        this.reWrite = true;
        // console.log(this.$refs);
        setTimeout(() => {
          //强哥给的放大镜方法，是好的
          this.$refs.crud.$children[1].$children[3].$el.addEventListener('click', () => {
            this.serachFlag = !this.serachFlag;
            this.clickChangeHeight();
          });
        });
      });

      //this.firstDisplayFlag = true;
    });
  },

  methods: {
    clickChangeHeight() {
      if (this.todoListLength === 0) {
        if (this.option.height == this.bodyHeight - 398 + (78 - 46)) {
          this.option.height = this.bodyHeight - 287 + (78 - 46);
        } else {
          this.option.height = this.bodyHeight - 398 + (78 - 46);
        }
      } else {
        if (this.option.height == this.bodyHeight - 398) {
          this.option.height = this.bodyHeight - 287;
        } else {
          this.option.height = this.bodyHeight - 398;
        }
      }

      this.$refs.crud.getTableHeight();
    },
    emptyForm() {
      this.form.id = '';
      this.form.projectId = '';
      this.form.name = '';
      this.form.code = '';
      this.form.typeId = '';
      this.form.typeName = '';
      this.form.specification = '';
      this.form.vender = '';
      this.form.measuringUnit = '';
      this.form.price = '';
      this.form.description = '';
      this.form.attachIds = '';
      this.form.attachList = [''];
      this.treeFormData = [];
      this.form.fileList = [''];
    },

    /* initSelect(){
         getProjectList().then((data)=>{
           this.projectList = data.data;
           if(this.projectList.length > 0){
             this.projectName = this.projectList[0].name;
             this.query.projectId = this.projectList[0].id;
             this.querySelect(this.projectList[0].id,)
           }
         });
       },*/
    typeLazyLoadTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
      } else {
        id = node.data.id;
      }
      let projectId;
      if (this.form.projectId) {
        projectId = this.form.projectId;
      } else if (this.query.projectId) {
        projectId = this.query.projectId;
      }
      tree({ id: id, projectId: projectId }).then(({ data }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
          });
        }
        resolve(data);
      });
    },
    typeNodeTreeClick(node) {
      console.log('dasdsa', node)
      let nodeId = node.id;
      let nodeTitle = node.name;
      if (this.form.projectId) {
        this.form.typeName = nodeTitle;
        this.form.typeId = nodeId;
      } else {
        this.query.typeName = nodeTitle;
        this.query.typeId = nodeId;
        this.$forceUpdate();
      }
      if(node.hasChildren){
        this.$refs.typeselectfef.blur()
      }
    },
    querySelect(value, type) {
      this.form.typeName = '';
      this.query.typeName = '';
      this.form.measuringUnit = '';
      this.query.measuringUnit = '';

      if (type === 1) {
        this.form.projectId = value;
      } else if (type === 2) {
        this.query.projectId = value;
        getProjectDict({ projectId: value, code: 'project_consumable_measuring_unit' }).then(
          ({ data }) => {
            if (this.operateType === 'add') {
              this.form.type = null;
            }
            const column1 = this.findObject(this.option.column, 'measuringUnit');
            this.measuringUnitList = data;
            // console.log(data);
            if (column1.dicData.length == 0) {
              column1.dicData = [{}];
            }
          }
        );
      }
      tree({ id: 0, projectId: value }).then(({ data }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
          });
        }
        if (type === 1) {
          this.treeFormData = data;
        } else if (type === 2) {
          this.treeSearchData = data;
        }
      });
      getProjectDict({ projectId: value, code: 'project_consumable_measuring_unit' }).then(
        (res) => {
          if (this.operateType === 'add') {
            this.form.type = null;
          }
          const column1 = this.findObject(this.option.column, 'measuringUnit');
          column1.dicData = res.data;
          if (column1.dicData.length == 0) {
            column1.dicData = [{}];
          }
        }
      );
    },
    rowSave(row, done, loading) {
      // console.log(row);
      row.img = '';
      add(row).then(
        () => {
          this.emptyForm();
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          // window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      console.log(this.form.fileList);
      row.img = '';
      row.attachIds = this.attachIdList.join(',');
      update(row).then(
        () => {
          this.emptyForm();
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          // window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },

    beforeAvatarUpload(file) {
      const isLt500KB = file.size / 1024 < 500;
      // console.log('file=========>', file);
      if (!(file.type.indexOf('image/') > -1)) {
        this.$message.error('请上传图片类型文件!');
      }
      if (!isLt500KB) {
        this.$message.error('上传文件大小不能超过 500KB!');
      }
      return isLt500KB && file.type.indexOf('image/') > -1;
    },
    fileUploadSuccess(response, file, fileList) {
      this.attachIdList.push(response.data.id);
      this.form.attachIds = this.attachIdList.join(',');
    },
    handlePictureCardPreview(file) {
      window.open(file.url);
      // console.log(this.form.fileList);
    },
    fileHandleRemove(file, fileList) {
      let delAttachId = '';
      if (file.id) {
        delAttachId = file.id;
      } else {
        delAttachId = file.response.data.id;
      }
      let index = this.attachIdList.indexOf(delAttachId);
      this.attachIdList.splice(index, 1);
      this.form.attachIds = this.attachIdList.join(',');
    },
    // handlePreview(file) {
    //   console.log(file);
    //   },
    uploadBefore(file, done, loading) {
      let len = file.name.split('.').length;
      // console.log(file.type === 'image/jpeg' || file.type === 'image/png');
      // console.log(file.type);
      const isImage =
        (file.name.split('.')[len - 1] === 'png' || file.name.split('.')[len - 1] === 'jpg') &&
        (file.type === 'image/jpeg' || file.type === 'image/png');
      // console.log(isImage);
      const isLt500KB = file.size / 1024 < 500;
      if (!isImage) {
        this.$message.error('只能上传jpg/png格式的图片');
        loading();
        return;
      }
      if (!isLt500KB) {
        this.$message.error('上传图片大小不能超过500kb!');
        loading();
        return;
      }
      if (isImage && isLt500KB) {
        done();
      }
    },

    beforeClose(done, type) {
      this.emptyForm();
      this.treeFormData = [];
      this.attachIdList = [''];
      this.form = {};
      // this.form.attachIds = '';
      this.fileDisabled = false;
      done();
    },
    beforeOpen(done, type) {
      this.viewFlag = false;
      // console.log(type);
      this.form.flag = type;
      if (type === 'view') {
        this.viewFlag = true;
      }
      if (type === 'add') {
        this.formDisabled = false;
        this.form.attachIds = '';
        this.attachIdList = [''];
        /* setTimeout(() => {
            this.formDisabled=false;
            this.form.project = this.projectList[0].name;
            this.form.projectId = this.projectList[0].id;
            this.querySelect(this.form.projectId, 1);
          }, 0);*/
      }
      if (['edit', 'view'].includes(type)) {
        getAttachByMainIdList({ mainId: this.form.id }).then(({ data }) => {
          if (data) {
            data.forEach((item) => {
              item.url = item.link;
              this.attachIdList.push(item.id);
            });
            this.form.fileList = data;
            this.form.attachIds = this.attachIdList.join(',');
          }
        });
        if (['edit'].includes(type)) {
          this.formDisabled = false;
          this.formProjectisabled = true;
        }
        if (['view'].includes(type)) {
          this.formDisabled = true;
          this.fileDisabled = true;
          this.formProjectisabled = true;
        }

        setTimeout(() => {
          getDetail({ id: this.form.id }).then(({ data }) => {
            //this.form = data;
          });
        }, 0);
        setTimeout(() => {
          getProjectDict({
            projectId: this.form.projectId,
            code: 'project_consumable_measuring_unit',
          }).then((res) => {
            if (this.operateType === 'add') {
              this.form.type = null;
            }
            const column1 = this.findObject(this.option.column, 'measuringUnit');
            column1.dicData = res.data;

            column1.dicData.forEach((e) => {
              if (e.dictKey == this.form.measuringUnit) {
                document.querySelector(
                  'div[id*=el-collapse-content] > div > div > div:nth-child(8) > div > div > div > div.el-input.el-input--small.el-input--suffix > input[placeholder="请选择 计量单位"]'
                ).value = e.dictValue;
              }
            });
          });
        });
      } else {
        setTimeout(() => {
          // console.log(this.query.projectId);
          this.form.projectId = this.query.projectId;
        }, 0);
      }
      done();
    },

    searchReset() {
      // console.log(this.query);
      this.query.name = null;
      this.query.code = null;
      this.measuringUnitName = '';
      this.query.typeId = null;
      this.query.typeName = '';
      this.query.measuringUnit = null;
      this.onLoad();
    },
    searchChange(params, done) {
      // console.log(this.query.measuringUnit);
      params.projectId = this.query.projectId;
      this.query.name = params.name;
      this.query.code = params.code;
      params.measuringUnit = this.query.measuringUnit;
      this.$forceUpdate();
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      this.query.projectId = this.projectId;
      if (this.query.projectId) {
        getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
          ({ data }) => {
            this.todoListLength = data.records.length;
            if (this.serachFlag) {
              console.log(111111);
              if (data.records.length === 0) {
                this.option.height = this.bodyHeight - 398 + (78 - 46);
              } else {
                this.option.height = this.bodyHeight - 398;
              }
              this.$refs.crud.getTableHeight();
            }
            this.page.total = data.total;
            this.data = data.records;
            this.loading = false;
            this.selectionClear();
          }
        );
      } else {
        getProjectList().then((data) => {
          this.projectList = data.data;
          if (this.projectList.length > 0) {
            this.query.projectId = this.projectList[0].id;
            this.query.project = this.projectList[0].name;
            getList(
              Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)
            ).then(({ data }) => {
              this.page.total = data.total;
              this.data = data.records;
              this.loading = false;
              this.selectionClear();
            });
          }
        });
      }
    },
  },
};
</script>

<style lang="scss">
#exminetopic20211119 {
  .avue-crud .el-icon-view {
    display: none;
  }
  .avue-crud .el-icon-edit {
    display: none;
  }
  .avue-form__menu--center {
    text-align: right;
  }
  .avue-crud__search .el-form-item--small.el-form-item {
    width: 100%;
  }
}
</style>
<style scoped>
::v-deep .avue-crud .el-form-item {
  display: block;
}
.money {
  text-align: right;
}
</style>
<style>
#consumable20211203 .avue-form__menu--center {
  padding-right: 5px !important;
}
</style>
